import { useEffect, useRef, useState } from 'react';

import { useTranslationX } from 'i18n';
import { useAppContext } from 'context';
import { Overlay } from 'components';
import { Loader } from 'components/ui';
import { ObjectId } from 'types';

import styles from './Interaction.module.scss';

type Props = {
  url: string;
  id: ObjectId;
  mode: string;
  onClose: () => void;
};

const Interaction = ({ url, id, mode, onClose }: Props) => {
  const [visible, setVisible] = useState(true);
  const [loading, setLoading] = useState(true);
  const [showControls, setShowControls] = useState(false);

  const { auth } = useAppContext();
  const { tx } = useTranslationX('play.home.interaction');

  const timerRef = useRef<NodeJS.Timeout>();

  useEffect(() => {
    timerRef.current = setTimeout(() => setShowControls(true), 2000);

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);

  if (!auth.userId) {
    return null;
  }

  url = `${url}/${mode}/${id}/${auth.userId}`;

  return (
    <Overlay visible={visible} onClose={onClose}>
      {size => (
        <div className={styles.interaction}>
          <iframe
            src={url}
            title={tx('title')}
            onLoad={() => {
              setLoading(false);

              if (timerRef.current) {
                clearTimeout(timerRef.current);
                timerRef.current = setTimeout(() => setShowControls(true), 1000);
              }
            }}
          />

          {showControls && (
            <div
              className={styles.closeButton}
              onClick={() => setVisible(false)}
              style={
                size ? { fontSize: size.width * (size.full ? 0.015 : 0.01) } : undefined
              }
            />
          )}

          <Loader visible={loading} className={styles.loader} />
        </div>
      )}
    </Overlay>
  );
};

export default Interaction;
